define('Store.Cookie', [
    'Utilities.CookieJar'
], function StoreCookie(
    CookieJar
) {
    return {
        set: function set(id) {
            var dateExp = new Date();
            dateExp.setMonth(dateExp.getMonth() + 12);

            CookieJar.setItem('AWSpreferredStore', id, dateExp, '/');
        },
        get: function get() {
            return CookieJar.getItem('AWSpreferredStore');
        }
    };
});
